export enum ActorType {
  User = 'user',
  System = 'system',
  Cli = 'cli',
}

export const ACTOR_TYPE_LABELS: Record<ActorType, string> = {
  [ActorType.User]: 'User',
  [ActorType.System]: 'System',
  [ActorType.Cli]: 'CLI',
};
